<template>
    <TMobileServices
        v-model="sortingValue"
        :footer-button-text="footerButtonText"
        :active-buttons="indexPanelActiveButtons"
        :current-letter-index-panel="currentLetterIndexPanel"
        :sorting-buttons="sortingPanelButtons"
        sorting-panel
        class="o-mobile-services"
        color="#E25046"
        :theme="'back'"
        @onFooterButton="handleClickBack"
    >
        <template #header>
            <AMHeaderItems
                color="#E25046"
                :title="$t('ui.service-category')"
                :subtitle="$t('ui.service-category.description')"
                right-slot
                @onClose="emitClickBack"
            >
                <template #left>
                    <AMBackButton
                        v-if="isLandscape"
                        theme="back"
                        :text="$t('ui.back')"
                        @onClick="handleClickBack"
                    />
                    <svg-icon
                        v-else
                        original
                        name="icons/mobile_items_services"
                        class="mobile-services__header-icon"
                    />
                </template>
                <template #right>
                    <AMItemsCloseButton
                        v-if="!isLandscape && isCloseButtonShow"
                        @onClick="handleClickBack"
                    />
                    <AMBackButton
                        v-if="isLandscape"
                        theme="close"
                        :text="$t('ui.close')"
                        @onClick="handleClickBack"
                    />
                </template>
            </AMHeaderItems>
        </template>
        <template #container>
            <RecycleScroller
                #default="{ item }"
                :items="items"
                :item-size="isLandscape ? 40 : 97"
                class="mobile-services__scroller"
            >
                <OWServicesTile
                    :item="item"
                    @onClick="handleTileClick"
                />
            </RecycleScroller>
        </template>
    </TMobileServices>
</template>

<script>
import uniq from "lodash/uniq";
    
import {
    mapState,
    mapGetters
} from 'vuex';

import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import AMHeaderItems from '../../atoms/a-m-header-items/a-m-header-items';
import TMobileServices from '../../templates/t-mobile-items/t-mobile-items';
import OWServicesTile from '../../organisms/o-w-services-tile/o-w-services-tile';
import AMItemsCloseButton from '../../atoms/a-m-items-close-button/a-m-items-close-button';

import {
    MOBILE_ROOT,
    MOBILE_GUIDE,
    MOBILE_SERVICE,
    MOBILE_SERVICES
} from '../../../utils/constants/pages';

export default {
    name: 'OMobileServices',
    components: {
        AMBackButton,
        AMHeaderItems,
        OWServicesTile,
        TMobileServices,
        AMItemsCloseButton
    },
    data() {
        return {
            renderItems: 10,
            sortingValue: 'All',
            currentLetterIndexPanel: 'a'
        }
    },
    props: {
        /**
         * Use in case we need to exclude some item from tenants list.
         * For example: items on searchbar on guide screen
         */
        filteredByItem: {
            type: Number,
            default: null
        },
        isCloseButtonShow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape,
        }),
        ...mapGetters([
            't',
            'getObject',
            'getServiceCategoriesAZ'
        ]),
        service() {
            return this.getObject(this.filteredByItem);
        },
        items() {
            const items = [...this.getServiceCategoriesAZ];
            if (this.filteredByItem && this.service.type === 'service' || this.filteredByItem && this.service.lists['service_categories']) {
                const filtered = [];
                items.forEach(item => {
                    if (this.service.lists.categories ? this.service.lists.categories.includes(item.id) : this.service.lists['service_categories'].includes(item.id)) {
                        if (item.objectsCount > 1) {
                            item.objectsCount -= 1;
                            filtered.push(item);
                        }
                    } else {
                        filtered.push(item);
                    }
                });
                return this.filteredItemsBySortingValue(filtered);
            } else {
                return this.filteredItemsBySortingValue(items);
            }
        },
        footerButtonText() {
            return this.$route.name === MOBILE_SERVICES ? this.$t('ui.close') : this.$t('ui.back')
        },
        /**
         * Detects active letters for index panel
         * * @returns {object|Array}
         */
        indexPanelActiveButtons() {
            return uniq(this.items.map((item) => {
                return this.t(item, "name").charAt(0).toLowerCase();
            }));
        },
        /**
         * Detects what letters will render in sorting panel
         * @returns {object|Array}
         */
        sortingPanelButtons() {
            return uniq(this.getServiceCategoriesAZ.map((item) => {
                return this.t(item, "name").charAt(0);
            }));
        }
    },
    methods: {
        filteredItemsBySortingValue(data) {
            if (this.sortingValue && this.sortingValue !== 'All') {
                const valueLength = this.sortingValue.length;
                const selectedItems = [];
                for (let i = 0; i < valueLength; i++) {
                    selectedItems.push(...data.filter(name => {
                        const firstLetter = this.t(name, "name").charAt(0);
                        return firstLetter === this.sortingValue.charAt(i);
                    }));
                }
                return selectedItems;
            }
            return data;
        },
        handleTileClick(data) {
            switch (this.$route.name) {
            case MOBILE_SERVICES:
                this.redirectToService(data);
                break;
            case MOBILE_GUIDE:
                this.changeExtremePoint(data);
                break;
            default:
                break;
            }
        },
        handleClose() {
            this.redirectToHome();
        },
        redirectToService(data) {
            const params = {
                name: MOBILE_SERVICE,
                query: {
                    id: data.id
                }
            };
            this.$router.push(params);
        },
        handleClickBack() {
            if (this.$route.name === MOBILE_SERVICES) this.redirectToHome();
            else this.emitClickBack();
        },
        emitClickBack() {
            this.$emit('onClickBack', true);
        },
        redirectToHome() {
            const params = {
                name: MOBILE_ROOT
            };
            this.$router.push(params);
        },
        changeExtremePoint(data) {
            this.$emit('onServiceData', data);
        }
    }
}
</script>

<style lang="scss">
@import "o-mobile-services";
</style>